import { isServer } from 'lib/utils'

const INSTRUCTION = 'hasWrittenInstruction'

export default function useRequestInstruction(): {
  hasWrittenInstruction: boolean
  setWrittenInstruction: (value: boolean) => void
  clearWrittenInstruction: () => void
} {
  const hasWrittenInstruction = JSON.parse(
    !isServer() && window.sessionStorage.getItem(INSTRUCTION),
  )

  const setWrittenInstruction = (value: boolean) => {
    window.sessionStorage.setItem(INSTRUCTION, JSON.stringify(value))
  }

  const clearWrittenInstruction = () => {
    window.sessionStorage.removeItem(INSTRUCTION)
  }

  return {
    hasWrittenInstruction,
    setWrittenInstruction,
    clearWrittenInstruction,
  }
}
